import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function () { return ({
    components: {
        MuiAccordion: {
            defaultProps: {
                disableGutters: false,
                sx: { boxShadow: 0 },
            },
            styleOverrides: {
                root: {
                    backgroundColor: '#F8F8F8',
                    '&:first-of-type': {
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: '8px',
                        borderBottomRightRadius: '8px',
                    },
                    ':before': {
                        backgroundColor: 'rgba(0, 0, 0, 0.08)',
                    },
                    '&.Mui-expanded': {
                        margin: 0,
                        ':before': {
                            opacity: 1,
                        },
                    },
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    fontSize: designTokens.typography.heading.sub.size.value,
                    fontWeight: 600,
                    '&.Mui-expanded': {
                        minHeight: '48px',
                    },
                },
                content: {
                    '&.Mui-expanded': {
                        margin: '12px 0',
                    },
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    fontSize: designTokens.typography.body.long1.size.value,
                    lineHeight: designTokens.typography.body.short1.lineHeight.value,
                    padding: '0 16px 16px',
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=accordionTheme.js.map